import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import StateFileSub from "../../Components/StateFileSub";
import { parse, isAfter, isBefore, isEqual } from "date-fns";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ShowFileGeneralStatus(props) {
  const apiToken = useContext(TokenContext);
  const [newRefundList, setNewRefundList] = useState([]);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    selectedState: "",
    selectedImportoMin: "",
    selectedImportoMax: "",
    selectedAnnouncement: "",
    selectedCitizenData: "",
  });
  const [announcementNames, setAnnouncementNames] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState({});

  useEffect(() => {
    fetchData(apiToken, "1f0e0b25-dc9b-43f1-6ee7-08dd097b400d");
  }, [apiToken, filters]);

  const fetchData = (apiToken, selectedId) => {
    Repo.getRefoundReceiptNewList(apiToken, selectedId)
      .then((response) => {
        Repo.getListaInterventi(apiToken)
          .then((response) => {
            setAnnouncementNames(response.data);
          })
          .catch((error) => {
            console.log(error);
          });

        const filteredData = filterData(response.data);
        setNewRefundList(filteredData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const parseDateForDataInsert = (dateStr) => {
    return parse(dateStr, "dd/MM/yyyy", new Date());
  };

  const filterData = (data) => {
    let filteredData = data;

    if (filters.startDate) {
      const startDateParsed = parse(
        filters.startDate,
        "yyyy-MM-dd",
        new Date()
      );
      filteredData = filteredData.filter(
        (item) =>
          isAfter(parseDateForDataInsert(item.dataInsert), startDateParsed) ||
          isEqual(parseDateForDataInsert(item.dataInsert), startDateParsed)
      );
    }

    if (filters.endDate) {
      const endDateParsed = parse(filters.endDate, "yyyy-MM-dd", new Date());
      filteredData = filteredData.filter(
        (item) =>
          isBefore(parseDateForDataInsert(item.dataInsert), endDateParsed) ||
          isEqual(parseDateForDataInsert(item.dataInsert), endDateParsed)
      );
    }

    if (filters.selectedState) {
      filteredData = filteredData.filter(
        (item) => parseInt(item.state) === parseInt(filters.selectedState)
      );
    }

    if (filters.selectedImportoMin) {
      filteredData = filteredData.filter(
        (item) => parseInt(item.valore) >= parseInt(filters.selectedImportoMin)
      );
    }

    if (filters.selectedImportoMax) {
      filteredData = filteredData.filter(
        (item) => parseInt(item.valore) <= parseInt(filters.selectedImportoMax)
      );
    }

    if (filters.selectedAnnouncement) {
      filteredData = filteredData.filter(
        (item) => item.announcementName === filters.selectedAnnouncement
      );
    }

    if (filters.selectedCitizenData) {
      const searchTerm = filters.selectedCitizenData.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          item.subscriptionUserFiscalcode.toLowerCase().includes(searchTerm) ||
          item.subscriptionUser.toLowerCase().includes(searchTerm)
      );
    }

    return filteredData;
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = announcementNames.find(
      (option) => option.value === selectedValue
    );
    setSelectedAnnouncement(selectedOption || {});

    if (selectedValue) {
      fetchData(apiToken, selectedValue); // Chiama il metodo con il nuovo valore selezionato
    }
  };

  const handleDownload = () => {
    const exportData = newRefundList.map((item) => ({
      "Codice Fiscale": item.subscriptionUserFiscalcode,
      "Nome Utente": item.subscriptionUser,
      "Intervento Collegato": item.announcementName,
      Data: item.dataInsert,
      Stato: getStateLabel(item.state),
      Importo: item.valore
        ? parseFloat(item.valore).toLocaleString("it-IT", {
            style: "currency",
            currency: "EUR",
          })
        : "-",
      Note: item.description,
      IBAN: item.subscriptionUserIBAN,
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    ws["!cols"] = [
      { wch: 20 }, // Codice Fiscale
      { wch: 20 }, // Nome Utente
      { wch: 50 }, // Intervento Collegato
      { wch: 15 }, // Data
      { wch: 15 }, // Stato
      { wch: 15 }, // Importo
      { wch: 30 }, // Note
      { wch: 25 }, // IBAN
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rimborsi");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([excelBuffer], { type: "application/octet-stream" }),
      "rimborsi.xlsx"
    );
  };

  const getStateLabel = (state) => {
    switch (parseInt(state)) {
      case 0:
        return "Caricato";
      case 1:
        return "Validato";
      case 2:
        return "Rifiutato";
      case 3:
        return "Pagato";
      default:
        return "Sconosciuto";
    }
  };

  return (
    <>
      <div>
        <h1>Rimborso utenti</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p> Di seguito le nuove ricevute caricate dagli utenti</p>
        </div>

        {/*Inizo download*/}

        <div className="row mb-2 text-right">
          <div className="col-lg-12 clearfix">
            <button
              type="button"
              className="btn btn-outline-success float-right p-2"
              onClick={handleDownload}
            >
              <svg className="icon icon-success">
                <use href={`${iconSprite}#it-download`} />
              </svg>{" "}
              <span className="align-middle">Scarica Excel</span>
            </button>
          </div>
        </div>

        {/*Inizo download*/}

        <div className="row">
          <div className="select-wrapper col-4">
            <select
              name="selectedAnnouncement"
              value={selectedAnnouncement?.value || ""} // Usa il valore corrente o una stringa vuota
              onChange={handleSelectChange}
            >
              <option value="">-- Seleziona --</option>
              {announcementNames.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-4">
            <input
              type="text"
              name="selectedCitizenData"
              value={filters.selectedCitizenData}
              onChange={handleFilterChange}
              placeholder="Dati cittadino"
            />
          </div>

          <div className="select-wrapper col-4">
            <select
              name="selectedState"
              value={filters.selectedState}
              onChange={handleFilterChange}
            >
              <option value=""> -Seleziona Stato- </option>
              <option value="0">Caricato</option>
              <option value="1">Validato</option>
              <option value="2">Rifiutato</option>
              <option value="3">Pagato</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-3">
            <input
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={handleFilterChange}
              placeholder="Data da"
            />
          </div>
          <div className="form-group col-3">
            <input
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={handleFilterChange}
              placeholder="Data a"
            />
          </div>
          <div className="form-group col-3">
            <input
              type="text"
              name="selectedImportoMin"
              value={filters.selectedImportoMin}
              onChange={handleFilterChange}
              placeholder="Importo maggiore di"
            />
          </div>
          <div className="form-group col-3">
            <input
              type="text"
              name="selectedImportoMax"
              value={filters.selectedImportoMax}
              onChange={handleFilterChange}
              placeholder="Importo minore di"
            />
          </div>
        </div>

        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Dati cittadino</th>
              <th scope="col">Intervento collegato</th>
              <th scope="col">Data</th>
              <th scope="col">Stato</th>
              <th scope="col">Importo</th>
              <th scope="col">Note</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {newRefundList &&
              newRefundList.length > 0 &&
              newRefundList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <strong>{item.subscriptionUserFiscalcode}</strong>{" "}
                    {item.subscriptionUser}
                  </td>
                  <td>{item.announcementName}</td>
                  <td>{item.dataInsert}</td>
                  <td>
                    <StateFileSub stateValue={item.state} />
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {item.valore
                      ? parseFloat(item.valore).toLocaleString("it-IT", {
                          style: "currency",
                          currency: "EUR",
                        })
                      : "-"}
                  </td>
                  <td>{item.description}</td>
                  <td style={{ textAlign: "right" }}>
                    <Link
                      to={
                        "/visualizza_rimborso?idRefund=" +
                        item.storageFileId +
                        "&id=" +
                        item.id
                      }
                    >
                      <button
                        className="btn btn-outline-primary p-1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-search`} />
                        </svg>
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ShowFileGeneralStatus;
